import styled from 'styled-components';
import { breakpoints } from 'src/styles/theme';
import { StepNavigationStyled } from '@components/v2/StepNavigation/StepNavigationStyled';
import { rem } from 'polished';

export const StepNavigationStyledDS = styled(StepNavigationStyled)`
    background: ${({ theme }) => theme.colors.grey4};

    .opened,
    .closed {
        .contactUsContainer {
            font-weight: bold;
            padding-left: ${rem(32)};
            color: ${({ theme }) => theme.colors.black};

            .contactUsActionButton {
                background: none;
            }

            .contactUsNumber {
                color: ${({ theme }) => theme.colors.secondary};
            }

            .contactUsTitle svg path {
                fill: ${({ theme }) => theme.colors.black};
            }
        }

        .wrapper {
            .blurryHolder {
                @media (min-width: ${breakpoints.lg}px) {
                    .icon-wrapper {
                        position: absolute;
                        z-index: 999;

                        &:after {
                            width: 20px;
                            height: 20px;
                            display: flex;
                            content: ${({ theme }) => `url('data:image/svg+xml;utf8,
                                <svg aria-hidden="true" width="20px" height="20px" viewBox="0 0 11 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.15203 18.3188L1.72319 18.8789L10.5765 9.85176L1.48033 0.914551L0.919647 1.4852L9.44565 9.86224L1.15203 18.3188Z" fill="${encodeURIComponent(
                                      theme.colors.primary
                                  )}" stroke="${encodeURIComponent(theme.colors.primary)}" stroke-width="1.2"></path>
                                </svg>')`};
                        }

                        svg {
                            display: none;
                        }
                    }
                }
            }
            .container {
                .nav-item {
                    &:hover,
                    &:focus-visible {
                        color: ${({ theme }) => theme.colors.black};
                        border-color: ${({ theme }) => theme.colors.secondary};

                        .withIcon {
                            background: ${({ theme }) => theme.colors.secondary};
                            border-color: ${({ theme }) => theme.colors.secondary};

                            svg {
                                g {
                                    fill: ${({ theme }) => theme.colors.white};
                                }
                            }
                        }
                    }

                    @media (min-width: ${breakpoints.lg}px) {
                        border-bottom: ${rem(3)} solid ${({ theme }) => theme.colors.white};

                        &.selected {
                            border-bottom: ${rem(3)} solid ${({ theme }) => theme.colors.secondary};
                        }
                    }

                    .icon,
                    .withIcon {
                        width: ${rem(28)};
                        height: ${rem(28)};
                    }

                    .icon {
                        background: ${({ theme }) => theme.colors.grey16};
                        border-color: ${({ theme }) => theme.colors.grey16};
                        svg {
                            margin-top: ${rem(5)};
                            margin-left: ${rem(5)};

                            g {
                                fill: ${({ theme }) => theme.colors.white};
                            }
                        }
                    }
                    .withIcon {
                        svg {
                            g {
                                fill: ${({ theme }) => theme.colors.secondary};
                            }
                        }
                    }
                    .title {
                        font-size: ${({ theme }) => theme.fontSizes.h6};
                        font-weight: ${({ theme }) => theme.fontWeights.textBold};
                    }
                }
            }
        }
    }
`;
